import 'css-chunksrc/client/scenes/taskStatusRemoval/statusSelect/styles.scss';export default {
  "statusSelect": "_statusSelect_j0v64_1",
  "status": "_status_j0v64_1",
  "label": "_label_j0v64_16",
  "placeholder": "_placeholder_j0v64_29",
  "group": "_group_j0v64_34",
  "icon": "_icon_j0v64_43",
  "list": "_list_j0v64_49",
  "item": "_item_j0v64_63",
  "statusLabel": "_statusLabel_j0v64_79",
  "statusColor": "_statusColor_j0v64_85",
  "open": "_open_j0v64_91"
};